import useClientSpecificLocation from '@ubeya/shared/hooks/account/useClientSpecificLocation';
import React from 'react';
import LocationModal from './LocationModal';

const ClientLocationModal = ({
  selectedLocationId,
  onClose,
  onConfirm,
  clientId,
  clientBranchId,
  branchesOptions = [],
  showBranchSelector = false,
  editableAddress = false,
  disableFieldsEdit = false
}) => {
  const { data: selectedClientLocation, isLoading: isLoadingSelectedClientLocation } = useClientSpecificLocation({
    locationId: selectedLocationId,
    withAttachments: true,
    clientId,
    clientBranchId
  });

  const selectedLocation = { ...selectedClientLocation, branchId: clientBranchId };

  return (
    <LocationModal
      disableFieldsEdit={disableFieldsEdit}
      selectedLocation={selectedLocation}
      isLoadingSelectedLocation={isLoadingSelectedClientLocation}
      onClose={onClose}
      onConfirm={onConfirm}
      editableAddress={editableAddress}
      showBranchSelector={showBranchSelector}
      branchesOptions={branchesOptions}
      disableBranchEdit={!!selectedLocation.branchId}
    />
  );
};

export default ClientLocationModal;
